<template>
  <div class="app">
    <div class="box">
      <div class="box_left">
        <div class="left_tit">
          <p class="p1">{{ title }}</p>
          <p class="p2">{{ item }}</p>
        </div>
        <div class="left_cen" v-html="htmldata"></div>
        <!-- <div class="left_cen" v-html="html"></div> -->
      </div>
      <div class="box_right">
        <div class="right_tit">
          <div class="tit_ico"></div>
          <div class="tit_p">其他新闻</div>
        </div>
        <div class="rig_data">
          <ul v-for="(item, index) in listnameArr1" :key="index">
            <li
              :class="[item.id == bty ? 'green' : '']"
              @click="handelNewcik(item.id)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="box-btm"><Contact></Contact></div>
  </div>
</template>

<script>
import Contact from "../home/components/Contact.vue";
import Newscen from "../newsxq/components/Newscen";
import { contentList } from "../../assets/api/indexl";
export default {
  // 组件名称
  name: "more",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    Contact,
    // Newscen,
  },
  // 组件状态值
  data() {
    return {
      listnameArr1: [],
      key: "",
      bty: "",
      title: "",
      item: "",
      htmldata: "",
      list: [],
      // html: '<div><p>河南科技学院基建处刘处长、财务处张处长一行莅临河南羿赐智能科技有限公司考察调研，受到羿赐智能科技张亚朝董事长的热情接待，双方针对大学校园内教学楼、办公楼、食堂、体育馆、图书馆和人才公寓等各类建筑设施的节能改造、打造绿色低碳校园等议题进行了深入探讨。</p><img src="http://47.105.58.2:9000/images/images3/hnkj1.jpeg" alt="" /><p>张亚朝董事长介绍了羿赐智能科技在暖通领域二十多年积累和沉淀的经验与理念，并结合同类高校的节能实践应用案例，为客人们介绍了羿赐智能科技的解决方案。在能量来源方面，羿赐智能科技优先选择地源热泵、水源热泵、再生水热泵技术，从土壤、地下井水、污水中水、工业废水、矿井坑道水、洗浴废水、地表水中提取热能供暖、冷能供冷，在不具备上述条件时再通过空气源热泵从空气中提取能量，解决各类建筑物的供冷供暖供生活热水需求。</p><img src="http://47.105.58.2:9000/images/images3/hnkj2.jpeg" alt="" /><p>针对大学校园内建筑功能多样化、高大建筑空间耗能严重、高峰负荷时段互补性强、人员众多需求难调等诸多特征，羿赐智能科技通过AI智慧能源管理系统实现了按需定产、精准供能。这一系统利用智慧能源管理平台的AI边缘计算和深度学习，结合各类建筑物空调系统历史运营数据、大学校园的作息时间和寒暑假，精确计算空调系统的能源消耗规律，从而科学设定能源站的设施配置和运行模式，使整个能源站系统始终处于最经济节能的运行工况，实现了大学校园的低碳环保、安全运营。</p><img src="http://47.105.58.2:9000/images/images3/hnkj3.jpeg" alt="" /><p>河南科技学院基建处刘处长、财务处张处长一行通过案例现场的针对性分析与讲解，深切感受到羿赐智能科技的产品及技术对校园节能的重要价值，初步确定将以合同能源管理形式进行合作，下周将安排羿赐技术人员进行现场考察，确定技改实施方案。</p></div>',
    };
  },
  inject: ["reload"],
  watch: {},
  // 组件初始化
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.key = localStorage.getItem("newkey");
    this.bty = localStorage.getItem("newkey");
    contentList().then((res) => {
      console.log(res);
      this.list = res.data.result;
      this.listnameArr1 = JSON.parse(JSON.stringify(res.data.result));
      this.listnameArr1.splice(this.key - 1, 1);
      this.title = this.list[this.bty - 1].title;
      this.item = this.list[this.bty - 1].subtitle;
      this.htmldata = this.list[this.bty - 1].content;
    });
    var currentURL = window.location.href;
    this.$emit("passfunction", currentURL);
  },
  // 组件实例挂载完毕
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  destroyed() {},
  computed: {},
  destroyed() {},
  // 组件方法
  methods: {
    handelNewcik(type) {
      this.bty = type;
      this.title = this.list[this.bty - 1].title;
      this.item = this.list[this.bty - 1].subtitle;
      this.htmldata = this.list[this.bty - 1].content;
    },
  },
};
</script>

<style scoped lang="less">
.app {
  width: 100%;
  height: 100%;
  // background-color: aquamarine;
  display: flex;
  flex-direction: column;
  padding: 0.1px;
  background-color: #f9f9f9;
}
.box {
  width: 1040px;
  min-height: 850px;
  margin: 100px auto;
  display: flex;
  // border: 1px solid gold;
  .box_left {
    width: 722px;
    padding: 24px;
    // border: 1px solid greenyellow;
    background-color: rgba(255, 255, 255, 1);
    .left_tit {
      width: 674px;
      height: 85px;
      // border: 1px solid gold;
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      .p1 {
        font-weight: 600;
        font-size: 20px;
        color: #1b1e20;
      }
      .p2 {
        font-weight: 400;
        font-size: 14px;
        color: #b1b1b1;
        margin-top: 10px;
      }
    }
    .left_cen {
      width: 674px;
      // border: 1px solid gold;
      /deep/p {
        font-weight: 400;
        font-size: 16px;
        color: #1b1e20;
        line-height: 24px;
        margin-top: 24px;
        text-indent: 32px;
      }
      /deep/img {
        width: 100%;
        height: 430px;
        margin-top: 24px;
      }
      /deep/.p-h1 {
        color: red;
        text-align: center;
        margin-top: 24px;
      }
      /deep/.p-h2 {
        color: red;
        margin-top: 24px;
      }
    }
  }
  .box_right {
    width: 298px;
    margin-left: 20px;
    max-height: 477px;
    // max-height: 600px;
    background-color: rgba(255, 255, 255, 1);
    .right_tit {
      width: 250px;
      height: 68px;
      margin: 0 auto;
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      display: flex;
      .tit_ico {
        width: 24px;
        height: 24px;
        // border: 1px solid gold;
        margin-top: 26px;
        background-image: url("../../assets/imgs/lb.png");
        background-size: 100% 100%;
      }
      .tit_p {
        margin-left: 10px;
        margin-top: 26px;
        font-weight: 600;
        font-size: 20px;
        color: #1b1e20;
      }
    }
    .rig_data::-webkit-scrollbar {
      display: none;
    }
    .rig_data {
      width: 250px;
      margin: 0 auto;
      max-height: 477px;
      overflow: hidden;
      overflow-y: scroll;
    }
    li:hover {
      color: #0072ff;
      text-decoration: underline;
    }
    .green {
      color: #0072ff;
      text-decoration: underline;
    }
    ul li {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      height: 50px;
      line-height: 50px;
      list-style: none;
      border-bottom: 1.5px solid #f5f5f5;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #3d485d;
      cursor: pointer;
    }
  }
}
.box-btm {
  width: 100%;
  height: 214px;
  background-color: black;
  margin-bottom: 0px;
}
</style>
